// placeholder for interfaces that are shared across the whole app

export interface RouteParams {
	id: string;
}

export interface Window {
	gtag: any;
	grecaptcha: any;
}

export enum ExtraDomainProfileType {
	ParentVolunteer = 'ParentVolunteer'
}
